/**
 * Motion for bottom sheets: the sheet slides on the iOS sheet curve (quick start, long
 * settle) and leaves faster, easing in, since the user has already moved on. Keyframes
 * live in globals.css; the `sheet-in` / `sheet-out` classes are what its
 * prefers-reduced-motion block swaps for a plain fade.
 */
export const SHEET_EXIT_MS = 220;

export function sheetAnimation(closing: boolean): string {
  return closing
    ? `sheetOut ${SHEET_EXIT_MS}ms cubic-bezier(0.4, 0, 1, 1) forwards`
    : 'sheetIn 340ms cubic-bezier(0.32, 0.72, 0, 1)';
}

export function scrimAnimation(closing: boolean): string {
  return closing ? `fadeOut ${SHEET_EXIT_MS}ms ease-in forwards` : 'fadeIn 240ms ease-out';
}

export function sheetClassName(closing: boolean): string {
  return closing ? 'sheet-out' : 'sheet-in';
}
